// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"Yr-z","giftOrPromoSelector":"Zr-z","disabled":"_r-z","subTitle":"as-z","selectShipAddressMessage":"bs-z","changePayment":"cs-z"};